
import { supabase } from "@/integrations/supabase/client";

/**
 * Sends a message to the reagent owner as part of a swap request
 */
export const sendMessageToOwner = async (
  reagentId: string, 
  userId: string, 
  message: string,
  swapRequestId?: string
): Promise<boolean> => {
  const { data: reagentData, error: reagentError } = await supabase
    .from("reagents")
    .select("user_id")
    .eq("id", reagentId)
    .single();
    
  if (reagentError) {
    console.error("Error fetching reagent owner:", reagentError);
    return false;
  }

  // Create action button payload for swap requests
  const actionButton = swapRequestId ? {
    actionButton: {
      text: "View Swap Request",
      url: `/swap-request/${swapRequestId}`,
      type: "primary"
    }
  } : null;
  
  const { error: messageError } = await supabase
    .from("messages")
    .insert({
      sender_id: userId,
      recipient_id: reagentData.user_id,
      reagent_id: reagentId,
      content: message,
      read: false,
      payload: actionButton
    });
    
  if (messageError) {
    console.error("Error sending message:", messageError);
    return false;
  }
  
  return true;
};
